import { render, staticRenderFns } from "./FormS18MembersResolution.vue?vue&type=template&id=6c978404&scoped=true&"
import script from "./FormS18MembersResolution.vue?vue&type=script&lang=js&"
export * from "./FormS18MembersResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c978404",
  null
  
)

export default component.exports